<template>
	<div class="logon">
		<div class="logon_header w1200 flex">
			<router-link to="/" class="logon_header_logo"><img :src="public.top_logo" class="block" /></router-link>
			<div class="logon_header_r tc f16px">
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_index.png" />
					<p>返回首页</p>
				</router-link>
				<router-link to="" class="logon_header_list cl_dark">
					<img src="../../static/icon_logon.png" />
					<p>注册教程</p>
				</router-link>
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_sign.png" />
					<p>直接登录</p>
				</router-link>
			</div>
		</div>
		<div class="logon_cont">
			<div class="w1200">
				<div class="vip_cont">
					<input type="text" v-model="code" class="vip_code_input f16px" placeholder="点击输入激活码" />
					<div class="famous_screen_list mat30">
						<el-select v-model="sdValue" placeholder="选择高考所在省份" class="f16px">
							<el-option v-for="item in sd":key="item.id" :label="item.name":value="item.id"></el-option>
						</el-select>
					</div>
					<button type="button" class="vip_bind f18px cl_white mat50" @click="bind">确认绑定</button>
					<router-link to="/vip_buy" class="vip_link f18px cl_white block mat30 tc">没有激活码，去购买</router-link>
					<div class="vip_cont_tip cl_white mat70">
						<h3 class="f16px">开通趣学运会员有两种方式：</h3>
						<p>1.线下购买会员卡，使用激活码在当前页面激活即可；</p>
						<p>2.点击在线购买，支付成功后您的账号将自动激活升级为VIP</p>
					</div>
				</div>
				<div class="logon_footer tc cl_violet">
					<div class="logon_footer_top f36px">
						<img src="../../static/phone_violet.png" />
						<span>{{public.web_phone}}</span>
					</div>
					<div class="logon_footer_btm mat10">
						<p>{{public.web_copyright}} | <a href="http://www.beian.gov.cn" target="_blank" class="cl_violet">{{public.web_record}}</a></p>
						<p class="mat5">{{public.company_name}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from '../router'
	export default {
		name: 'vip_code',
		components: {
		 
		},
		props: {
	
		},
		data () {
			return {
				public: {},
				sdValue: "", //属地
				sd: [],
				code: "",
			}
		},
		created() {
			
		},
		mounted() {
			this.getInfo();
			this.getSd();
		},
		methods: {
			getInfo () {
				var that = this;
				that.$get("/api/base/get_base_configuration_data",{})
				.then(res => {
					that.public = res.data;
				});
			},
			//属地
			getSd () {
				var that = this;
				that.$get("/api/careerbible/get_province_data",{})
				.then(res => {
					that.sd = res.data;
				});
			},
			//激活
			bind () {
				var that = this;
				that.$get("/api/user/activation_card",{
					token: localStorage.getItem("token"),
					cdkey: that.code,
					province_id: that.sdValue,
				})
				.then(res => {
					this.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
					setTimeout(() => {
						router.replace({path: '/'});
					}, 1500);
				});
			},
		},
	}
</script>

<style>
</style>
